import { useState } from "react";

import type { Language } from "~/lib/i18n";
import { useI18n } from "~/lib/i18n/use-i18n";

const languageOptions: Array<{
  code: Language;
  label: string;
  flagSrc: string;
  alt: string;
}> = [
  { code: "fr", label: "Français", flagSrc: "/flags/france.png", alt: "France flag" },
  { code: "ar", label: "العربية", flagSrc: "/flags/tunisia.png", alt: "Tunisia flag" },
  { code: "en", label: "English", flagSrc: "/flags/gb.png", alt: "United Kingdom flag" },
];

export function LanguageSwitcher() {
  const { lang, setLanguage } = useI18n();
  const [open, setOpen] = useState(false);

  const current = languageOptions.find((l) => l.code === lang) ?? languageOptions[0];

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        className="flex items-center gap-2 rounded-full bg-white px-3 py-2 text-sm font-medium text-gray-800 shadow ring-1 ring-gray-200 hover:ring-vibrant-green transition"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <img
          src={current.flagSrc}
          alt={current.alt}
          className="h-5 w-7 rounded-sm object-cover shadow-sm ring-1 ring-gray-200"
        />
        <span className="hidden sm:inline">{current.label}</span>
        <svg
          className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M5.23 7.21a.75.75 0 011.06.02L10 11.108l3.71-3.877a.75.75 0 111.08 1.04l-4.25 4.44a.75.75 0 01-1.08 0l-4.25-4.44a.75.75 0 01.02-1.06z"
            clipRule="evenodd"
          />
        </svg>
      </button>

      {open ? (
        <div className="absolute right-0 mt-2 w-44 rounded-xl bg-white p-2 shadow-lg ring-1 ring-gray-200 z-50">
          <div className="overflow-hidden rounded-lg">
            {languageOptions.map((option) => (
              <button
                key={option.code}
                type="button"
                onClick={() => {
                  setLanguage(option.code);
                  setOpen(false);
                }}
                className={`flex w-full items-center gap-3 px-3 py-2 text-left text-sm font-medium transition-colors ${
                  lang === option.code
                    ? "bg-[#e8f5e9] text-[#1565c0]"
                    : "hover:bg-gray-100 text-gray-800"
                }`}
              >
                <img
                  src={option.flagSrc}
                  alt={option.alt}
                  className="h-5 w-7 rounded-sm object-cover shadow-sm ring-1 ring-gray-200"
                />
                <span>{option.label}</span>
              </button>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}

